import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { TablerIconsModule } from 'angular-tabler-icons';
import { TranslateModule } from '@ngx-translate/core';
import { LoginService } from 'src/app/login.service';
import { DashboardService } from './dashboard.service';
import { IDashboardResult } from './idashboard';
import { PatientViewComponent } from '../patient/patient-view/patient-view.component';
import { MatDialog } from '@angular/material/dialog';
import { IPatientInfo } from '../patient/ipatient-info';
import { PatientService } from '../patient/patient.service';
import { HasRoleDirective } from 'src/app/common/directive/has-role.directive';
import { ROLE_GROUPS } from 'src/app/common/authorization/roles';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MaterialModule,
    TablerIconsModule,
    TranslateModule,
    RouterModule,
    HasRoleDirective
  ],
  styleUrls: ['./dashboard.component.scss'],
})
export class DashBoardComponent implements OnInit {
  readonly ROLE_GROUPS = ROLE_GROUPS;
  dashboard: IDashboardResult | null = null;
  showIPD: boolean = false;
  showPharmacy: boolean = false;
  today = new Date();

  displayedColumns: string[] = ['patientName', 'patientNumber', 'lastVisitDate', 'doctorName'];

  readonly ringCircumference = 2 * Math.PI * 52; // r=52

  constructor(
    private dashboardService: DashboardService,
    private loginService: LoginService,
    private router: Router,
    private dialog: MatDialog,
    private _patientService: PatientService
  ) { }

  ngOnInit(): void {
    this.showIPD = this.loginService.isIPDTabShown();
    this.showPharmacy = this.loginService.isPharmacyEnabled();
    this.loadDashboard();
  }

  loadDashboard(): void {
    this.dashboardService.getDashboard().subscribe({
      next: (res) => {
        if (res.isSuccess) {
          this.dashboard = res.result;
        }
      },
      error: (err) => {
        console.error('Failed to load dashboard data', err);
      },
    });
  }

  navigateTo(route: string): void {
    this.router.navigate([route]);
  }

  get bedOccupancyPercent(): number {
    if (!this.dashboard || this.dashboard.totalBeds === 0) return 0;
    return Math.round((this.dashboard.occupiedBeds / this.dashboard.totalBeds) * 100);
  }

  get ringOffset(): number {
    return this.ringCircumference * (1 - this.bedOccupancyPercent / 100);
  }

  viewPatientDetails(patientId: number): void {
    this._patientService.getPatientByID(patientId).subscribe({
      next: (response) => {
        this.dialog.open(PatientViewComponent, {
          autoFocus: false,
          position: { top: '0', right: '0' },
          height: '100vh',
          width: '82vw',
          maxWidth: '1400px',
          panelClass: 'side-panel',
          data: {
            patient: response.result as IPatientInfo
          }
        });
      },
      error: (err) => {
        console.error('Error fetching patient details', err);
      }
    });
  }

}
